const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerships(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m165.759 97.074 22.63 23.998 36.488 10.19a102.735 102.735 0 0 1 31.743 15.11M94.334 292.814a102.744 102.744 0 0 1-14.346-39.761l-3.68-26.285-22.63-23.998M410.046 302.07l20.149 21.367c9.732 10.32 9.256 26.576-1.065 36.309-10.32 9.732-26.576 9.256-36.309-1.065l-25.044-26.557",
    style: {
      strokeWidth: 22,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.778 332.124 42.666 45.244c9.732 10.32 9.256 26.576-1.065 36.309h0c-10.32 9.732-26.576 9.256-36.309-1.065l-42.666-45.244",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.404 367.368 25.044 26.557c9.732 10.32 9.256 26.576-1.065 36.309h0c-10.32 9.732-26.576 9.256-36.309-1.065l-25.044-26.557",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.031 402.612 13.296 14.099c9.732 10.32 9.256 26.576-1.065 36.309-10.32 9.732-26.576 9.256-36.309-1.065l-20.652-21.9",
    style: {
      strokeWidth: 22,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.641 287.921-26.557 25.044c-10.32 9.732-10.797 25.988-1.065 36.309h0c9.732 10.32 25.988 10.797 36.309 1.065l26.557-25.044c10.32-9.732 10.797-25.988 1.065-36.309h0c-9.733-10.321-25.989-10.797-36.309-1.065z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.885 325.295-45.244 42.666c-10.32 9.732-10.797 25.988-1.065 36.309h0c9.732 10.32 25.988 10.797 36.309 1.065l45.244-42.666c10.32-9.732 10.797-25.988 1.065-36.309h0c-9.733-10.321-25.989-10.798-36.309-1.065z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.129 362.668-26.557 25.044c-10.32 9.732-10.797 25.988-1.065 36.309h0c9.732 10.32 25.988 10.797 36.309 1.065l26.557-25.044c10.32-9.732 10.797-25.988 1.065-36.309h0c-9.732-10.321-25.988-10.797-36.309-1.065z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.373 400.042-14.099 13.296c-10.32 9.732-10.797 25.988-1.065 36.309h0c9.732 10.32 25.988 10.797 36.309 1.065l14.099-13.296c10.32-9.732 10.797-25.988 1.065-36.309h0c-9.732-10.321-25.988-10.798-36.309-1.065z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.907 214.565-23.998 22.63-5.213 26.024a102.73 102.73 0 0 1-16.65 38.85l-80.831-85.714c-19.465-20.641-51.977-21.594-72.618-2.129l-14.919 14.069c-16.499 15.559-42.486 14.797-58.045-1.702l-7.073-7.5 63.931-60.288a102.74 102.74 0 0 1 48.699-25.657l37.022-8.034 23.998-22.63",
    style: {
      strokeWidth: 22,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.855 52.142h49.642v176.606h-49.642z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "rotate(-44.161 421.653 140.442)",
    fill: "none",
    stroke: "#0e9941",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#33cccc",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.337 106.485h176.606v49.642H3.337z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "rotate(-44.161 91.634 131.3)",
    fill: "none",
    stroke: "#0e9941",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#33cccc",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerships);
export default __webpack_public_path__ + "static/media/partnerships.6107655dd10aab95dc60913a1ccced38.svg";
export { ForwardRef as ReactComponent };